export default class TeamLightbox {
	constructor(root) {
		this.root = root;
		this.closeBtns = root?.querySelectorAll('.team-lightbox-close');

		this.closeBtns?.forEach((btn) => {
			btn.addEventListener('click', () => {
				this.close();
			});
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				this.close();
			}
		});
	}

	open(id) {
		document.body.classList.add('overflow-hidden');
		this.root?.classList.add('active');

		this.root?.querySelectorAll('.team-lightbox-inner').forEach((inner) => {
			const innerId = inner.getAttribute('data-id');

			if (innerId === id) {
				inner.classList.remove('hidden');
			} else {
				inner.classList.add('hidden');
			}
		});
	}

	close() {
		document.body.classList.remove('overflow-hidden');
		this.root.classList.remove('active');
	}
}
